import { Ruler, Calculator, ArrowDownUp, TrendingUp, XCircle, type LucideIcon } from 'lucide-react';

// Hex colors for inline style use (charts, progress bars, icons)
export const DATA_QUALITY_COLORS: Record<string, string> = {
  measured: '#5ee9b5',            // dark-green
  calculated: '#00bc7d',          // medium-green
  calculated_fallback: '#007a55', // dark-green
  estimated: '#f59e0b',           // darkest-orange
  failed: '#ef4444',              // red
};

// Lucide icons for each quality level
export const DATA_QUALITY_ICONS: Record<string, LucideIcon> = {
  measured: Ruler,
  calculated: Calculator,
  calculated_fallback: ArrowDownUp,
  estimated: TrendingUp,
  failed: XCircle,
};
